import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'cellNotes'

const LIST_CELL_NOTE_INDICATORS = createRequestTypes(prefix, 'LIST_CELL_NOTE_INDICATORS')

export const [
  LIST_CELL_NOTE_INDICATORS_REQUEST,
  LIST_CELL_NOTE_INDICATORS_SUCCESS,
  LIST_CELL_NOTE_INDICATORS_FAILURE,
] = LIST_CELL_NOTE_INDICATORS

const LIST_CELL_NOTE_LINKS = createRequestTypes(prefix, 'LIST_CELL_NOTE_LINKS')
export const [
  LIST_CELL_NOTE_LINKS_REQUEST,
  LIST_CELL_NOTE_LINKS_SUCCESS,
  LIST_CELL_NOTE_LINKS_FAILURE,
] = LIST_CELL_NOTE_LINKS

const CONFIRM_CELL_NOTE_LINK = createRequestTypes(prefix, 'CONFIRM_CELL_NOTE_LINK')
export const [
  CONFIRM_CELL_NOTE_LINK_REQUEST,
  CONFIRM_CELL_NOTE_LINK_SUCCESS,
  CONFIRM_CELL_NOTE_LINK_FAILURE,
] = CONFIRM_CELL_NOTE_LINK

const DISMISS_CELL_NOTE_LINK = createRequestTypes(prefix, 'DISMISS_CELL_NOTE_LINK')
export const [
  DISMISS_CELL_NOTE_LINK_REQUEST,
  DISMISS_CELL_NOTE_LINK_SUCCESS,
  DISMISS_CELL_NOTE_LINK_FAILURE,
] = DISMISS_CELL_NOTE_LINK

// Action creators
export const listCellNoteIndicators = createAction(
  (params?: {
    tableType: string
    workflow: string
    id: string
    clientName?: string
    rowIds?: string[]
    columnIds?: string[]
    globalColumnIds?: string[]
    recordDate?: string | string[]
  }) => ({
    type: LIST_CELL_NOTE_INDICATORS,
    promise: (api: IApi) => api.cellNotes.listIndicators(params),
    params,
  }),
)

export const listCellNoteLinks = createAction(
  (params?: {
    tableType: string
    workflow: string
    id: string
    rowId: string
    columnId: string
    columnIds?: string[]
    recordDate?: string
  }) => ({
    type: LIST_CELL_NOTE_LINKS,
    promise: (api: IApi) => api.cellNotes.listLinksForCell(params),
    params,
  }),
)

export const confirmCellNoteLink = createAction((id: string, params?: object) => ({
  type: CONFIRM_CELL_NOTE_LINK,
  promise: (api: IApi) => api.cellNotes.confirmLink(id),
  params: { id, ...params },
}))

export const dismissCellNoteLink = createAction((id: string, params?: object) => ({
  type: DISMISS_CELL_NOTE_LINK,
  promise: (api: IApi) => api.cellNotes.dismissLink(id),
  params: { id, ...params },
}))
